import { render, staticRenderFns } from "./OfficeRatingSettings.vue?vue&type=template&id=45ee47a0&"
import script from "./OfficeRatingSettings.vue?vue&type=script&lang=js&"
export * from "./OfficeRatingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports